import { render, staticRenderFns } from "./MNProviderTariff.vue?vue&type=template&id=59010c61&"
import script from "./MNProviderTariff.vue?vue&type=script&lang=ts&"
export * from "./MNProviderTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports